import styled from "styled-components";

export const SettingContainer = styled.div`
  background-color: #fafcff;
  padding: 26px 30px;
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  max-height: calc(100vh - 57px);
  > div {
    width: 100%;
    background-color: var(--inner-section-bg);
  }
  /* @media (max-width: 1564px) {
    flex-direction: column;
    > div {
      flex: none;
    }
  } */
`;
export const ActionBtn = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  margin-top: 10px;
  padding: 0 21px;

  button {
    width: 111px;
    height: 43px;
    background: transparent;
    border-radius: 30px;
    border: 1px solid #636f7c;
    font-family: "latobold";
    font-size: 16px;
    :last-child {
      background: var(--theme-background);
      color: #fff;
      border: none;
    }
  }
`;
export const PopContainer = styled.div`
  padding: 0;
  .modal-body {
    padding: 10px 29px;
    .input-wrapper {
      margin-bottom: 18px;
      p {
        font-size: 13px;
        line-height: 150.5%;
        color: #000;
        margin-bottom: 10px;
      }
      input {
        background: #ffffff;
        border: 1px solid #cdcfd0;
        border-radius: 6px;
        max-width: 344px;
        width: 100%;
        height: 26px;
        margin-bottom: 14px;
        padding: 0 8px;
      }
      .des {
        color: #636f7c;
        font-size: 12px;
      }
    }
  }
  ${ActionBtn} {
    margin: 0 0 18px;
    justify-content: center;
  }
`;
export const ModalHeader = styled.h3`
  font-size: 14px;
  line-height: 150.5%;
  padding: 10px 28px;
  background: var(--filter-bar-bg);
  border-radius: 5px 5px 0px 0px;
  color: var(--theme-text);
`;
export const SettingsWrapper = styled.div`
  padding: 14px 30px 0;
  .header {
    padding-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    button {
      height: 30px;
      font-size: 13px;
      line-height: 150.5%;
      border-radius: 30px;
      border: 1px solid #636f7c;
      display: flex;
      align-items: center;
      gap: 10px;
      background: transparent;
      justify-content: center;
      padding: 0 10px;
      &.active {
        background: var(--theme-background);
        color: var(--theme-text);
        border: none;
        svg {
          path {
            fill: var(--input-background);
          }
        }
      }
    }
  }
  .action-wrapper {
    gap: 10px;
    margin-bottom: 0;
    display: flex;
    ::after {
      display: none;
    }
    button {
      height: 30px;
      font-size: 13px;
      padding: 5px 10px;
      line-height: 150.5%;
      border-radius: 30px;
      border: 1px solid #636f7c;
      color: #1d1d1d;
      display: flex;
      align-items: center;
      gap: 10px;
      background: transparent;
      justify-content: center;
      &.active {
        background: var(--theme-background);
        color: var(--theme-text);
        border: none;
        svg {
          path {
            fill: var(--input-background);
          }
        }
      }
    }
  }
`;

export const PaceTimer = styled.div`
  display: flex;
  gap: 20px 60px;
  flex-wrap: wrap;
  input[type="number"]::-webkit-inner-spin-button {
    width: 20px;
    height: 26px;
  }
  > div {
    display: flex;
    align-items: center;
    /* margin-bottom: 25px; */
    ::after {
      content: "min";
      font-size: 12px;
      color: #6c6c6c;
      margin-left: 6px;
    }
    p {
      font-size: 16px;
      line-height: 150.5%;
      color: #1d1d1d;
      min-width: 126px;
      padding-right: 10px;
    }
    /* input[type="number"] {
      -webkit-appearance: textfield;
      -moz-appearance: textfield;
      appearance: textfield;
    } */

    input {
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      height: 30px;
      font-size: 13px;
      line-height: 150.5%;
      padding: 5px 4px 5px 9px;
      max-width: 46px;
    }
    /* input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      opacity: 1;
      -webkit-appearance: none;
    } */
    &.behind-pace {
      input {
        background: rgba(255, 231, 102, 0.2);
        border: 1px solid #ffe766;
      }
    }
    &.critically-behind {
      input {
        background: rgba(250, 74, 116, 0.2);
        border: 1px solid #fa4a74;
      }
    }
  }
  @media (max-width: 1564px) {
    display: flex;
    justify-content: space-between;
  }
`;

export const HoleWrapper = styled.div`
  padding: 33px 25px;
  background-color: var(--inner-section-bg);
  display: flex;
  gap: 24px;
  overflow: auto;
  flex-wrap: wrap;
`;
export const HoleBox = styled.div`
  border: 1px solid #cdcdcd;
  border-radius: 5px;
  input[type="number"]::-webkit-inner-spin-button {
    width: 20px;
    height: 26px;
  }
  .header {
    height: 31px;
    background: var(--box-header-background);
    display: flex;
    align-items: center;
    justify-content: center;
    h3 {
      font-weight: 700;
      font-size: 16px;
      line-height: 150.5%;
    }
  }
  .box {
    padding: 0 26px;
    .row {
      border-bottom: 1px solid #d1d0cb;
      padding: 12px 0 16px;
      display: flex;
      gap: 20px;
      justify-content: space-between;
      .hole-div {
        span {
          background: var(--theme-background);
          width: 26px;
          height: 26px;
          font-weight: 500;
          font-size: 15px;
          line-height: 150.5%;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          margin-bottom: 15px;
          margin-left: 9px;
          color: var(--theme-text);
        }
        input {
          background: #ffffff;
          border: 1px solid #cdcfd0;
          border-radius: 6px;
          font-size: 13px;
          line-height: 150.5%;
          height: 30px;
          width: 48px;
          margin-right: 1px;
          padding: 2px 0 2px 13px;
          text-align: center;
        }
        ::after {
          content: "min";
          font-size: 12px;
          color: #6c6c6c;
        }
      }
      .total-time {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom: 5px;
        p {
          font-weight: 700;
          font-size: 15px;
          line-height: 150.5%;
          :last-child {
            font-weight: 500;
            font-size: 13px;
          }
        }
      }
    }
    .last-row {
      display: flex;
      justify-content: flex-end;
      gap: 30px;
      padding-bottom: 9px;
      padding-top: 4px;
      p {
        font-weight: 700;
        font-size: 15px;
        line-height: 150.5%;
        :last-child {
          font-weight: 500;
          font-size: 13px;
        }
      }
    }
  }
`;
